export var facilityUser = function facilityUser(centralApi) {
  return {
    index: function index(params) {
      if (params === void 0) {
        params = null;
      }
      return centralApi.get('/facility-user', {
        params: params
      });
    },
    post: function post(data) {
      if (data === void 0) {
        data = null;
      }
      return centralApi.post('/facility-user', data);
    },
    put: function put(id, data) {
      if (data === void 0) {
        data = null;
      }
      return centralApi.put("/facility-user/".concat(id), data);
    }
  };
};